module.exports = __webpack_public_path__ + "phone@2x.9889c210997723b6b7b9d24a48dd81ef.png";